<template>
  <div style="width: 100%">
    <div v-if="!showLeaveWord">
      <div v-if="showMap" style="padding-left: 100px">
        <div style="height: 50px; line-height: 50px; background-color: #000; color: #fff">
          {{ addr }}
        </div>
        <el-amap
          vid="amap"
          :plugin="plugin"
          style="height: 600px"
          :center="center"
          lang="zh_en"
          :zoom="zoom"
        >
          <el-amap-marker
            v-for="marker in markers"
            :key="marker"
            :position="marker.position"
            :events="marker.events"
            :label="marker.label"
            :content="marker.content"
          ></el-amap-marker>
        </el-amap>
      </div>
      <div v-if="news && news.length > 0 && showNewsList" style="padding-left: 120px">
        <div class="news-title">{{ newsTitle }}</div>
        <div style="max-height: 605px; overflow: auto">
          <NewsItem
            v-for="(item, index) in showNews"
            :key="index"
            :news="item"
            :lang="lang"
            @click.native="newsClick(item, index)"
          />
        </div>
        <el-pagination
          background
          style="float: right; margin-top: 20px"
          layout="prev, pager, next"
          :page-size="5"
          :total="newsCount"
          @current-change="pageChange"
        >
        </el-pagination>
      </div>
      <div v-html="content" class="content"></div>
    </div>

    <div v-if="showLeaveWord">
      <el-row>
        <el-col :span="12"
          ><div v-if="showMap" style="padding-left: 100px">
            <el-amap
              vid="amap"
              :plugin="plugin"
              style="height: 300px"
              :center="center"
              lang="zh_en"
              :zoom="zoom"
            >
              <el-amap-marker
                v-for="marker in markers"
                :key="marker"
                :position="marker.position"
                :events="marker.events"
                :label="marker.label"
                :content="marker.content"
              ></el-amap-marker>
            </el-amap></div
        ></el-col>
        <el-col :span="12">
          <div v-html="content" class="content"></div>
          <!-- <div>{{ addr }}</div> -->
        </el-col>
      </el-row>

      <div style="padding-left: 100px">
        <h1 class="leave-word-title">
          {{ lang == "EN" ? "留言咨询" : "Leave Content：" }}
        </h1>
        <div class="form-line">
          <div class="form-label">
            {{ lang == "EN" ? "发表您的留言" : "Leave Content：" }}
          </div>
        </div>
        <el-row>
          <el-col :span="12">
            <div class="form-line">
              <div class="form-label">
                {{ lang == "EN" ? "姓名：" : "Name:" }}
              </div>
              <el-input v-model="name"> </el-input>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="form-line">
              <div class="form-label">
                {{ lang == "EN" ? "邮箱：" : "Email：" }}
              </div>
              <el-input v-model="email"> </el-input>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div class="form-line">
              <div class="form-label">
                {{ lang == "EN" ? "电话：" : "Phone：" }}
              </div>
              <el-input v-model="phone"> </el-input>
            </div>
          </el-col>
          <el-col :span="12"> </el-col>
        </el-row>

        <div class="form-line">
          <div class="form-label">
            {{ lang == "EN" ? "留言：" : "Leave Content：" }}
          </div>
          <el-input type="textarea" :rows="4" v-model="leaveWord"> </el-input>
        </div>

        <div class="form-line" style="justify-content: center">
          <el-button type="primary" round @click="publish">{{
            lang == "EN" ? "发布" : "Send"
          }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { addLeaveWord } from "@/api/data.js";
import NewsItem from "./NewsItem";

let newsIndex = 0;

export default {
  props: {
    content: String,
    showMap: Boolean,
    chartData: String,
    chartSetting: String,
    pageName: String,
    showLeaveWord: Boolean,
    lang: String,
    news: Array,
    newsTitle: String,
  },
  components: { NewsItem },
  data() {
    return {
      name: "",
      email: "",
      phone: "",
      leaveWord: "",
      imgUrl: require("../assets/location.svg"),
      addr: "",
      center: [117.148118, 36.660223],
      markers: [],
      zoom: 14,
      showNews: [],
      newCurrentPage: 0,
      newsCount: 0,
      plugin: [
        {
          enableHighAccuracy: true, //是否使用高精度定位，默认:true
          timeout: 100, //超过10秒后停止定位，默认：无穷大
          maximumAge: 0, //定位结果缓存0毫秒，默认：0
          convert: true, //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
          showButton: true, //显示定位按钮，默认：true
          buttonPosition: "RB", //定位按钮停靠位置，默认：'LB'，左下角
          showMarker: true, //定位成功后在定位到的位置显示点标记，默认：true
          showCircle: true, //定位成功后用圆圈表示定位精度范围，默认：true
          panToLocation: false, //定位成功后将定位到的位置作为地图中心点，默认：true
          zoomToAccuracy: false, //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：f
          extensions: "all",
          pName: "Geolocation",
          dest: "",

          events: {
            init(o) {
              // o 是高德地图定位插件实例
              o.getCurrentPosition((status, result) => {
                console.log(result);
              });
            },
          },
        },
      ],
      showNewsList: true,
    };
  },
  watch: {
    lang() {
      if (this.pageName == "news" && !this.showNewsList) {
        if (this.lang == "EN") {
          this.content = this.showNews[newsIndex].content;
        } else {
          this.content = this.showNews[newsIndex].enContent;
        }
      }
    },
    news() {
      this.newCurrentPage = 0;
      this.showNewsList = true;
      this.showNews = this.news.slice(0, 5);
      this.newsCount = this.news.length;
    },
    chartData() {
      this.center = this.chartData.center;
      this.zoom =
        this.chartData.zoom || this.chartData.zoom == 0 ? this.chartData.zoom : 10;
      let markers = [];
      let that = this;
      this.chartData.markers.forEach((element) => {
        markers.push({
          position: element.position,
          events: {
            mouseover: (e) => {
              console.log(e);
              that.addr = e.target.w.content.split("$$")[1];
            },
            mouseout: () => {
              that.addr = "";
            },
          },
          visible: true,
          draggable: false,
          title: "ssss",
          content: element.flag
            ? '<img width="40px" src="' +
              require("../assets/location_master.svg") +
              '"/><!--$$' +
              element.addr +
              "$$ -->"
            : '<img width="40px" src="' +
              require("../assets/location.svg") +
              '"/><!--$$' +
              element.addr +
              "$$ -->",
          label: {
            content: element.addr,
            offset: element.offset ? element.offset : [-5, -20],
          },
        });
      });
      this.markers = markers;
    },
  },
  methods: {
    newsClick(item, index) {
      newsIndex = index;
      this.showNewsList = false;
      if (this.lang == "EN") {
        this.content = item.content;
      } else {
        this.content = item.enContent;
      }
      console.log(item);
    },
    setNews(item) {
      this.showNewsList = false;
      if (this.lang == "EN") {
        this.content = item.content;
      } else {
        this.content = item.enContent;
      }
      console.log(item);
    },
    pageChange(index) {
      this.newCurrentPage = index - 1;
      this.newsDataChange();
    },
    newsDataChange() {
      this.showNews = this.news.slice(
        this.newCurrentPage * 5,
        (this.newCurrentPage + 1) * 5 > this.newsCount
          ? this.newsCount
          : (this.newCurrentPage + 1) * 5
      );
    },
    publish() {
      let that = this;
      addLeaveWord({
        name: that.name,
        email: that.email,
        phone: that.phone,
        leaveWord: that.leaveWord,
      })
        .then((response) => {
          console.log(response);
          if (response.status == 200 && response.data.code == 200) {
            that.$message("发布成功，感谢您的留言！");
            that.name = "";
            that.phone = "";
            that.email = "";
            that.leaveWord = "";
          } else {
            that.$message.error("发布失败，请重试！");
          }
        })
        .catch((res) => {
          console.log(res);
          that.$message.error("发布失败，请重试！");
        });
    },
  },
  mounted() {},
};
</script>

<style>
.news-title {
  text-align: left;
  font: 2em sans-serif;
  color: #039;
  margin-bottom: 20px;
}
.leave-word-title {
  text-align: left;
  font-weight: bold;
  height: 60px;
  line-height: 60px;
  border-bottom: solid 2px #e1e1e1;
}
.form-line {
  display: flex;
  margin-bottom: 20px;
  align-items: center;
}

.form-label {
  min-width: 120px;
}
.content {
  margin-left: 80px;
  line-height: normal;
  display: inline-block;
  width: 90%;
  text-align: left;
}
</style>
